import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "Admin", // From Auth
  about       : "System admin",
  photoURL    : '/admin.jpg', // From Auth
  status      : "online",
  userRole    : "admin"
}

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  let userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
} 
const getBrokers = () => {
  try{
    let brokers = JSON.parse(localStorage.getItem('brokersList'));
    return brokers
  } catch{ return []}
}
const getAgents = () => { 
  try{
    let agents = JSON.parse(localStorage.getItem('agentList'));
    return agents
  } catch{ return []}
}
const getAccounts = () => {
  try{
    let accounts = JSON.parse(localStorage.getItem('accountsList'));    
    return accounts
  } catch{ return []}
}

const getDocNames = () => {
  try{
    let docNames = JSON.parse(localStorage.getItem('docNamesList'));
    return docNames
  } catch{ return []}
}

const getDepartments = () => {
  try{
    let departments = JSON.parse(localStorage.getItem('departmentList'));
    return departments
  } catch{ return []}
}

const getPickLists = () => {
  try{
    let pickLists = JSON.parse(localStorage.getItem('pickLists'));
    return pickLists
  } catch{ return []}
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    pickLists               : getPickLists(),
    AppActiveUser           : getUserInfo(),
    brokers                 : getBrokers(),
    agents                  : getAgents(),
    accounts                : getAccounts(),
    docNames                : getDocNames(),
    departments             : getDepartments(),
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
}

export default state
